import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export default class BracketGamePredictionsFilters extends MainFiltersBQ {}
